module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-17-06-223.dbf3eb94.mp4";